import React, { Component } from 'react'
import { Modal, Input, Icon, Tag, notification, Tooltip, message, Button } from "antd"
import ListItemsQC from './selectItemsQC/ListItemsQC'
import ListItemsQCError from './selectItemsQC/ListItemsQCError'
import InfoBasket from './selectItemsQC/InfoBasket'
import '../styles/index.scss'
import { getMarkInformationV3, markCompletedByOrderIdV2, markError, markCompleted1STByOrderId } from "../../../services/api/3dApi"
import { addOrderToBasket } from '../../../services/api/mergerApi'
import convertDateOverTime from '../../../helpers/convertDateOverTime'
import * as applyBrandingForAllItems from '../../../configs/applyBrandingForAllItems'
import { ERROR_DETAIL } from '../helpers/errorDetail.json'
import Time_out_Sound from '../sounds/Time-out.mp3'
import QualityControlCountDown from './QualityControlCountDown'
import { resolveBrandDescriptions } from '../helpers/brandDescription'
import { EyeTwoTone } from '@ant-design/icons'

class MarkQC extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            loadingQC1ST: false,
            error: '',
            errorInput: '',
            barCode: '',
            inputValue: '',
            basketInfo: null,
            totalItems: 0,
            allItems: [],
            oneItem: [],
            outItems: [],
            typeQC: false,
            isAddBasket: false,
            defaultChecked: [],
            relatedSkuWithInputBarcode: {},
            allSelected: false,
            selectedItem: [],
            arrCheckError: [],
            tags: [],
            error_type: 'print',
            isOpen: false,

            markResults: {
                successResult: [],
                errorResult: [],
                addedBasket: null,
            },
            isCountDown: true,
            totalTimeQC: 0,
            isMoreThanTwoLines: false,
            showQchtModal: false,
            qchtPreviewImage: '',
        }
        this.sound = new Audio(Time_out_Sound)
        this.sound.loop = true // Bật loop âm thanh
    }

    _input = React.createRef()
    textRef = React.createRef()

    componentWillUnmount() {
        // dừng timer và âm thanh khi component bị unmount
        this.setState({ isCountDown: false, totalTimeQC: 0 })
        this.sound.pause()
        this.sound.currentTime = 0
    }

    checkTextHeight = () => {
        if (this.textRef.current) {
            const lineHeight = parseFloat(
                window.getComputedStyle(this.textRef.current).lineHeight
            )
            const maxHeight = lineHeight * 2
            this.setState({
                isMoreThanTwoLines: this.textRef.current.scrollHeight > maxHeight,
            })
        }
    }

    toggleCountDown = () => {
        this.setState({ isCountDown: !this.state.isCountDown })
    }

    stopSound = () => {
        this.setState({ isCountDown: false, totalTimeQC: 0 })
        this.sound.pause()
        this.sound.currentTime = 0
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const { allItems, selectedItem, defaultChecked } = this.state
        if ((prevState.selectedItem !== selectedItem) && selectedItem.length > 0) {
            this.setState({
                allSelected: allItems.length === selectedItem.length + defaultChecked.length,
            })
        }
    }

    _onPaste = (e) => {
        //e.preventDefault()
    }

    _handleChange = e => {
        let { value } = e.target

        this.setState({
            error: '',
            errorInput: '',
            inputValue: value,
        })
    }

    _onSubmit = (e) => {
        e.preventDefault()

        const { inputValue } = this.state
        const check = /^#\d+_\d+$/.test(inputValue)

        this.setState({
            allSelected: false,
            selectedItem: [],
            arrCheckError: [],
            markResults: {
                successResult: [],
                errorResult: [],
                addedBasket: null,
            },
            isCountDown: true,
            totalTimeQC: 0,
        })

        if (check) {
            this.setState({
                barCode: '',
                inputValue: inputValue,
            }, () => {
                const valueFormatted = inputValue.trim().replace(/^#/, '')

                if (!valueFormatted) {
                    return null
                }

                this._handleGetDataMark(valueFormatted)
            })
        } else {
            this.setState({
                barCode: '',
                errorInput: 'Item không đúng định dạng.',
            })
        }
    }

    _handleGetDataMark = async (value) => {
        this.setState({
            loading: true,
        })
        this.textRef.current = null
        try {
            const { data: response } = await getMarkInformationV3(value)
            const { data, success, error } = { ...response }
            if (!success) {
                return this.setState({
                    error: error,
                    loading: false,
                }, () => {
                    Modal.error({
                        title: 'Lỗi',
                        content: <div>{this.state.error}</div>,
                        onOk: this._resetScanInput(),
                        okText: 'Đóng',
                    })
                })
            }

            const { barcode, can_qc_multiple_items, can_add_to_basket, basket, sku, skuSizes } = data
            const { products, relatedSkuWithInputBarcode, tags } = barcode

            //Lấy ra index của item được quét vào
            const index = value.lastIndexOf("_")
            const itemIndex = value.substr(index + 1)

            //lấy ra item theo index của item
            const oneItem = products.filter(item => item.pos === parseInt(itemIndex))
            //Lấy ra các order còn lại trừ đơn được đưa vào
            const outItem = products.filter(item => item.pos !== parseInt(itemIndex))
            //Lấy ra các item không được phép đánh dấu
            const defaultChecked = products.filter(item => {
                return !item.can_qc_completed ? item._id : null
            })

            this.setState({
                loading: false,
                basketInfo: basket,
                allItems: products,
                oneItem: oneItem,
                outItems: outItem,
                defaultChecked: defaultChecked.map(item => item._id),
                typeQC: can_qc_multiple_items,
                isAddBasket: can_add_to_basket,
                totalItems: products.length,
                relatedSkuWithInputBarcode: relatedSkuWithInputBarcode,
                tags: tags,
                barcode,
                isCountDown: true,
                totalTimeQC: this.calculateTotalTime(can_qc_multiple_items ? products : oneItem),
                sku,
                skuSizes,
                //Reset state popup theo từng barcode: nếu để sót, popup của đơn trước sẽ tự bung ra
                //ở đơn sau mà QC viên chưa bấm icon nào (guard showQchtIcon chỉ ẨN, không reset state)
                showQchtModal: false,
                qchtPreviewImage: '',
            },
                () => {
                    const { oneItem: oneSelect, typeQC } = this.state
                    this.checkTextHeight()

                    if (!typeQC) {
                        this.setState({
                            selectedItem: [oneSelect[0].tool3d_order._id],
                        })
                    }
                },
            )
        } catch (e) {
            this.setState({
                error: e.message,
                loading: false,
            })
        }
    }

    _resetScanInput = () => {
        this.setState({
            loading: false,
            error: '',
            barCode: '',
            inputValue: '',
            basketInfo: null,
            totalItems: 0,
            arrChecked: [],
            allSelected: false,
            allItems: [],
            oneItem: [],
            outItems: [],
            typeQC: false,
            isAddBasket: false,
            selectedItem: [],
            arrCheckError: [],
            tags: [],
            error_type: 'print',
            isOpen: false,

            markResults: {
                successResult: [],
                errorResult: [],
                addedBasket: null,
            },
            isCountDown: true,
            totalTimeQC: 0,
            isMoreThanTwoLines: false,
            barcode: {},
            sku: {},
            skuSizes: {},
            showQchtModal: false,
            qchtPreviewImage: '',
        }, () => {
            this._input.current.focus()
        })
    }

    _updateOrdersSelected = (id, isAdded) => {
        const { selectedItem, defaultChecked, allItems } = this.state

        if (selectedItem.length + defaultChecked.length === allItems.length) {
            this.setState({
                allSelected: true,
            })
        } else {
            this.setState({
                allSelected: false,
            })
        }

        if (isAdded) {
            if (!selectedItem.includes(id)) {
                this.setState({
                    selectedItem: [...selectedItem, id],
                    allSelected: selectedItem.length + 1 === selectedItem.length,
                })
            }
        } else {
            const filtered = selectedItem.filter(orderId => orderId !== id)

            this.setState({
                selectedItem: filtered,
                allSelected: false,
            })
        }
    }

    _handleCheckError = (id, isAdded) => {
        const { arrCheckError } = this.state

        if (isAdded) {
            if (!arrCheckError.includes(id)) {
                this.setState({
                    arrCheckError: [...arrCheckError, id],
                })
            }
        } else {
            const filtered = arrCheckError.filter(orderId => orderId !== id)

            this.setState({
                arrCheckError: filtered,
                allSelected: false,
            })
        }
    }

    _toggleSelectAll = (isChecked) => {

        this.setState(() => {
            const { allItems } = this.state

            if (isChecked) {
                const orderIds = allItems.filter(order => order.can_qc_completed).map(item => item.tool3d_order._id)

                return {
                    selectedItem: orderIds,
                    allSelected: true,
                    arrCheckError: []
                }
            }

            return {
                selectedItem: [],
                allSelected: false,
            }
        })
    }

    _toggleSelectAllError = (isChecked) => {
        this.setState(() => {
            if (isChecked) {
                const { markResults } = this.state
                const { errorResult } = markResults
                const orderIds = errorResult.map(item => item.order._id)

                return {
                    selectedItem: orderIds,
                    allSelected: true,
                }
            }

            return {
                selectedItem: [],
                allSelected: false,
            }
        })
    }

    _cancelQC = () => {
        this.setState({
            loading: false,
            error: '',
            barCode: '',
            inputValue: '',
            basketInfo: null,
            totalItems: 0,
            allItems: [],
            oneItem: [],
            outItems: [],
            typeQC: false,
            isAddBasket: false,
            defaultChecked: [],

            allSelected: false,
            selectedItem: [],
            tags: [],

            markResults: {
                successResult: [],
                errorResult: [],
                addedBasket: null,
            },
            isCountDown: true,
            totalTimeQC: 0,
            isMoreThanTwoLines: false,
            barcode: {},
            sku: {},
            skuSizes: {},
            showQchtModal: false,
            qchtPreviewImage: '',
        }, () => {
            this._input.current.focus()
        })
    }

    _submitQC = async () => {
        const { selectedItem, inputValue, barCode, barcode, arrCheckError, allItems } = this.state
        const listGIFTBOX_0700NO = allItems.length > 0 ? allItems.filter(i => i.type === 'GIFTBOX_0700NO' && i.can_qc_completed) : []
        const listLPRO_ACCESS_00NO = allItems.length > 0 ? allItems.filter(i => i.type === 'LPRO_ACCESS_00NO' && i.can_qc_completed) : []
        const listBOX_0700NO = allItems.length > 0 ? allItems.filter(i => i.type === 'BOX_0700NO' && i.can_qc_completed) : []
        const listGIFTCARD_1800NO = allItems.length > 0 ? allItems.filter(i => i.type === 'GIFTCARD_1800NO' && i.can_qc_completed) : []
        const listIdGIFTBOX_0700NO = listGIFTBOX_0700NO.length > 0 ? listGIFTBOX_0700NO.map(i => i.tool3d_order._id) : []
        const listIdLPRO_ACCESS_00NO = listLPRO_ACCESS_00NO.length > 0 ? listLPRO_ACCESS_00NO.map(i => i.tool3d_order._id) : []
        const listIdBOX_0700NO = listBOX_0700NO.length > 0 ? listBOX_0700NO.map(i => i.tool3d_order._id) : []

        // const listIdGIFTCARD_1800NO = listGIFTCARD_1800NO.length > 0 ? listGIFTCARD_1800NO.map(i => i.tool3d_order._id) : []
        // const listBarcodeGIFTBOX_0700NO = allItems.length > 0 ? allItems.filter(i => i.type === 'GIFTBOX_0700NO').map(i => `${i.tool3d_order.barcode_number}_${i.tool3d_order.item_number}`) : []
        const newBarCode = barCode ? barCode : inputValue
        if (selectedItem.length === 0) {
            return this.setState({
                error: 'Chọn những đơn muốn quét QC',
            })
        }

        this.setState({
            loading: true,
            error: '',
            inputValue: '',
            barCode: newBarCode,
        })

        try {
            const isExistItemError = allItems.some(item => {
                const { tool3d_order = {} } = Object.assign({}, item)
                const { batch_item = {} } = { ...tool3d_order }
                const { error_at = '' } = Object.assign({}, batch_item)
                return error_at
            })
            const listItemOtherSelect = allItems.filter(i => {
                const { type, can_qc_completed, cannot_qc_completed_reason, tool3d_order = {} } = Object.assign({}, i)
                const { _id: idItem } = { ...tool3d_order }
                return !['GIFTBOX_0700NO', 'BOX_0700NO', 'LPRO_ACCESS_00NO'].includes(type) && can_qc_completed && !cannot_qc_completed_reason && !selectedItem.includes(idItem)
            }) || []
            const isAutoQcBox = listItemOtherSelect.every(i => ['THANK_CARD', 'BRAND_KIT', 'GIFTBOX_0700NO', 'GIFTCARD_1800NO', 'LPRO_ACCESS_00NO'].includes(i.type))

            const payload = {
                order_ids: (isAutoQcBox && !isExistItemError) ? [...new Set([...selectedItem, ...listIdGIFTBOX_0700NO, ...listIdBOX_0700NO, ...listIdLPRO_ACCESS_00NO])] : selectedItem
            }

            const { data: response } = await markCompletedByOrderIdV2(payload)
            const hasGiftBox = listGIFTBOX_0700NO && listGIFTBOX_0700NO.length
            const hasBrandBox = listBOX_0700NO && listBOX_0700NO.length
            const hasGiftCard = listGIFTCARD_1800NO && listGIFTCARD_1800NO.length
            const hasLPRO_ACCESS_00NO = listLPRO_ACCESS_00NO && listIdLPRO_ACCESS_00NO.length
            const hasThankCardOrBrandKit = allItems.length > 0 && allItems.some(i => ['THANK_CARD', 'BRAND_KIT'].includes(i.type) && i.can_qc_completed)
            const { success, data, error } = response

            if (!success) {
                return this.setState({
                    error: error,
                    loading: false,
                }, () => {
                    Modal.error({
                        title: 'Lỗi',
                        content: error,
                        onOk: this._resetScanInput(),
                        okText: 'Đóng',
                    })
                })
            }

            const { successOrders, failedOrders, addedBasket, addedBasketError = '' } = data
            if (!!addedBasketError) message.error(`Lỗi tạo giỏ, ${addedBasketError}`)

            this.stopSound()
            this.setState({
                error: '',
                loading: false,
                selectedItem: [],
                tags: [],
                oneItem: [],
                outItems: [],
                allSelected: false,
                // allItems: [],
                // arrCheckError: [],
                markResults: {
                    successResult: successOrders,
                    errorResult: failedOrders,
                    addedBasket: addedBasket !== undefined ? addedBasket : null,
                },
                isCountDown: true,
                totalTimeQC: 0,
            }, async () => {
                if (addedBasket !== undefined) {
                    Modal.info({
                        title: '',
                        icon: null,
                        okText: 'Đóng',
                        width: 1260,
                        content: (
                            <div className="mt-3">
                                <InfoBasket
                                    addedBasket={addedBasket}
                                    barcode={barcode}
                                    onClose={() => {
                                        Modal.destroyAll()
                                        if (arrCheckError.length > 0 && arrCheckError.length < allItems.length) return this._onOpenModal()
                                        this.setState({
                                            allItems: [],
                                        })
                                        this._input.current.focus()
                                    }}
                                />
                            </div>
                        ),
                        onOk: () => {
                            if (arrCheckError.length > 0 && arrCheckError.length < allItems.length) return this._onOpenModal()
                            this.setState({
                                allItems: [],
                            })
                        },
                    })
                } else {
                    if (successOrders && successOrders.length > 0 && (hasGiftBox || hasGiftCard || hasBrandBox || hasThankCardOrBrandKit || hasLPRO_ACCESS_00NO)) {
                        const dataBasket = []
                        for (let i = 0; i < successOrders.length; i++) {
                            const order = successOrders[i]
                            if (order.order) {
                                try {
                                    const { data: response } = await addOrderToBasket(`${order.order.barcode_number}_${order.order.item_number}`)
                                    if (response.success && response.data) {
                                        dataBasket.push(response.data)
                                    }
                                } catch (error) {
                                    console.log(error.message)
                                }
                            }
                        }

                        if (dataBasket && dataBasket.length > 0 && dataBasket[dataBasket.length - 1]) {
                            Modal.info({
                                title: '',
                                icon: null,
                                okText: 'Đóng',
                                width: 1260,
                                content: (
                                    <div className="mt-3">
                                        <InfoBasket
                                            addedBasket={dataBasket[dataBasket.length - 1]}
                                            barcode={barcode}
                                            onClose={() => {
                                                Modal.destroyAll()
                                                if (arrCheckError.length > 0 && arrCheckError.length < allItems.length) return this._onOpenModal()
                                                this.setState({
                                                    allItems: [],
                                                })
                                                this._input.current.focus()
                                            }}
                                        />
                                    </div>
                                ),
                                onOk: () => {
                                    if (arrCheckError.length > 0 && arrCheckError.length < allItems.length) return this._onOpenModal()
                                    this.setState({
                                        allItems: [],
                                    })
                                },
                            })
                        }
                    }
                    this.setState({
                        allItems: [],
                    })
                }
                this._input.current.focus()
            })


        } catch (e) {
            this.setState({
                loading: false,
            }, () => {
                Modal.error({
                    title: 'Lỗi',
                    content: e.message,
                    onOk: this._resetScanInput(),
                    okText: 'Đóng',
                })
            })
        }
    }

    _submitQC1ST = async () => {
        const { selectedItem, inputValue, barCode } = this.state
        const newBarCode = barCode ? barCode : inputValue

        if (selectedItem.length === 0) {
            return this.setState({
                error: 'Chọn những đơn muốn quét QC lần 1',
            })
        }

        this.setState({
            loadingQC1ST: true,
            error: '',
            inputValue: '',
            barCode: newBarCode,
        })

        try {
            const payload = { order_ids: selectedItem }

            const { data: response } = await markCompleted1STByOrderId(payload)

            const { success, data, error } = response

            if (!success) {
                return this.setState({
                    error: error,
                    loadingQC1ST: false,
                }, () => {
                    Modal.error({
                        title: 'Lỗi',
                        content: error,
                        onOk: this._resetScanInput(),
                        okText: 'Đóng',
                    })
                })
            }
            this.stopSound()
            this.setState({
                error: '',
                loadingQC1ST: false,
                allItems: [],
                selectedItem: [],
                tags: [],
                oneItem: [],
                outItems: [],
                allSelected: false,
                barCode: '',
                isCountDown: true,
                totalTimeQC: 0,
            }, () => {
                Modal.success({
                    title: 'Đánh dấu QC hoàn thành lần 1 thành công',
                    okText: 'Đóng ',
                    content: `Item ${newBarCode} đã được đánh dấu QC hoàn thành lần 1`,
                })
                this._input.current.focus()
            })


        } catch (e) {
            this.setState({
                loadingQC1ST: false,
            }, () => {
                Modal.error({
                    title: 'Lỗi',
                    content: e.message,
                    onOk: this._resetScanInput(),
                    okText: 'Đóng',
                })
            })
        }
    }

    _onMarkItemError = async () => {
        this.setState({
            loading: true,
            error: '',
        })

        try {
            const { allItems, arrCheckError, inputValue } = this.state
            const listSelectedError = allItems.filter(item => item.hasOwnProperty('tool3d_order') && arrCheckError.includes(item.tool3d_order._id))
            const isValidateErrDetail = listSelectedError.some(i => !!i.error_detail && i.error_detail.length > 100)

            if (isValidateErrDetail) {
                this.setState({ loading: false })
                return notification.error({
                    message: 'Đánh dấu lỗi không thành công',
                    description: `Nhập chi tiết lỗi tối đa 100 ký tự.`,
                })
            }

            const promises = listSelectedError.map(async res => {
                const payload = {
                    error_type: res.error_type,
                    // error_procedure: 'qc_completed',
                    error_detail: res.error_detail,
                    error_style: null,
                }

                const { tool3d_order } = { ...res }
                const id = tool3d_order.hasOwnProperty('batch_item') && tool3d_order.batch_item._id

                const { data: response } = await markError(id, payload)
                return response
            })

            const data = await Promise.all(promises)

            const isSuccess = data.every(item => item.success)
            const { message } = { ...data.find(item => !item.success) } || {}

            if (!isSuccess) {
                return this.setState({
                    loading: false,
                    error: message
                }, () => {
                    this._onCloseModal()

                    notification.error({
                        message: 'Đánh dấu lỗi không thành công',
                        description: `Bạn đã đánh dấu lỗi cho các item không thành công.`,
                    })
                })
            }

            this.setState({
                loading: false,
                error: '',
                allItems: [],
                arrCheckError: [],
                inputValue: '',
                tags: [],
                oneItem: [],
                outItems: [],
                basketInfo: null,
                isCountDown: true,
                totalTimeQC: 0,
            }, () => {
                this._onCloseModal()
                notification.success({
                    message: 'Đánh dấu lỗi thành công',
                    description: `Bạn đã đánh dấu lỗi cho các item thành công.`,
                })
            })
        } catch (e) {
            this.setState({
                loading: false,
                error: e.message
            }, () => {
                this._onCloseModal()
                notification.error({
                    message: 'Đánh dấu lỗi không thành công',
                    description: e.message,
                })
            })
        }
    }

    _onCloseModal = () => {
        this.setState({
            loading: false,
            isOpen: false,
            error_type: 'print',
        })
    }

    _onOpenModal = () => {
        this.setState({
            isOpen: true,
        })
    }

    _onOpenQchtModal = () => {
        this.setState({
            showQchtModal: true,
        })
    }

    //Màn này chỉ thao tác bằng súng scan. Click icon / ảnh làm blur input, và antd trả focus về
    //chính element đã click (rc-dialog focus lastOutSideFocusNode khi đóng) -> phải tự focus lại ô quét,
    //nếu không lần bắn súng scan kế tiếp sẽ rơi vào body và QC viên tưởng súng hỏng.
    _focusScanInput = () => {
        if (!!this._input.current) this._input.current.focus()
    }

    _onCloseQchtModal = () => {
        this.setState({
            showQchtModal: false,
            qchtPreviewImage: '',
        }, this._focusScanInput)
    }

    _handleChangeRadio = (value, product) => {
        const { allItems } = this.state
        const errorType = ERROR_DETAIL.find(error => error.name === value) || {}
        const { type_error = '' } = Object.assign({}, errorType)

        const newAllItems = allItems.map(item => {
            if (item.hasOwnProperty('tool3d_order') && item.tool3d_order.hasOwnProperty('_id') && product.hasOwnProperty('tool3d_order') &&
                item.tool3d_order._id === product.tool3d_order._id) {
                return {
                    ...item,
                    error_type: !!type_error ? type_error : 'other',
                    error_detail: value,
                }
            }
            return item
        })
        this.setState({
            allItems: newAllItems
        })
    }

    calculateTotalTime(items) {
        if (!!Array.isArray(items) && items.length > 0) {
            const firstTenItemsTime = 20 // 20 giây cho item từ 1 đến 10
            const nextItemsTime = 15 // 15 giây cho item từ 11 trở đi

            return items.filter((i) => (!(!i.can_qc_completed && !!i.cannot_qc_completed_reason)))
                .reduce((totalTime, item, index) => {

                    if (index < 10) {
                        return totalTime + firstTenItemsTime
                    } else {
                        return totalTime + nextItemsTime
                    }
                }, 0)
        }
        return 0
    }

    render() {
        const {
            loading,
            loadingQC1ST,
            basketInfo,
            inputValue,
            barCode,
            markResults,
            totalItems,
            allItems,
            selectedItem,
            typeQC,
            outItems,
            oneItem,
            defaultChecked,
            allSelected,
            isAddBasket,
            error,
            errorInput,
            relatedSkuWithInputBarcode,
            tags,
            isOpen,
            arrCheckError,
            barcode,
            totalTimeQC,
            isMoreThanTwoLines,
            sku,
            skuSizes,
            showQchtModal,
            qchtPreviewImage,
        } = this.state
        const { successResult, errorResult } = markResults
        const [orderItem] = Array.isArray(oneItem) ? [...oneItem] : [oneItem]
        const isSpecialTag = orderItem && orderItem.tags && Array.isArray(orderItem.tags) && orderItem.tags.includes('priority-store')
        const isGiftTag = Array.isArray(tags) && tags.includes('gift')
        const isSampleTag = Array.isArray(tags) && tags.includes('sample')
        const isFbaTag = Array.isArray(tags) && (tags.includes('FBA') || tags.includes('fba'))
        const isFastShipTag = Array.isArray(tags) && tags.includes('fastship')
        const brandKitItems = allItems && Array.isArray(allItems) ? allItems.filter(item => item.type === "BRAND_KIT") : []
        const isMultipleBrandingItems = applyBrandingForAllItems.isSupport(barcode)
        const isFastProductionTag = Array.isArray(tags) && tags.includes('fastproduction')
        const isTikTokTag = Array.isArray(tags) && tags.includes('tiktok')
        const isCutoffTag = Array.isArray(tags) && tags.includes('cutoff')
        const isCutOffNoel = Array.isArray(tags) && tags.includes('cutoff_noel')
        const isCutOffNewYear = Array.isArray(tags) && tags.includes('cutoff_new_year')
        const isWoodTag = Array.isArray(tags) && tags.includes('wood_product')
        const isMadeInVN = Array.isArray(tags) && tags.includes('made_vn')
        const isPhotoRequest = Array.isArray(tags) && tags.includes('photo_requested')
        const { storename, note: noteOrder = '' } = { ...barcode }
        const soundTimeOut = this.sound
        const isSLL = Array.isArray(tags) && tags.includes('SLL')

        //Mô tả QCHT của các SKU đang hiển thị trên màn hình, gộp các item cùng SKU + brand
        const { brands_description_packaged: brandsDescriptionPackaged = [] } = { ...relatedSkuWithInputBarcode }
        const qchtRows = (typeQC ? allItems : []).reduce((rows, i) => {
            const { type = '', brand_name = '' } = { ...i }
            const key = `${type}|${brand_name}`

            if (rows.some(row => row.key === key)) return rows

            //descriptions: tối đa 1 khối — ưu tiên mô tả của brand item, không có thì fallback DEFAULT
            const descriptions = resolveBrandDescriptions(brandsDescriptionPackaged, brand_name)

            if (!descriptions.length) return rows

            return [...rows, { key, type, brand_name, descriptions }]
        }, [])

        //Đơn chỉ có 1 item thì mô tả đã hiển thị thẳng trên giao diện (xem ListItemsQC) -> không cần popup.
        //Dùng CHUNG 1 cờ cho icon và guard Modal: nếu chỉ ẩn icon, showQchtModal còn sót true từ barcode
        //trước (_onSubmit không reset state này) sẽ làm popup vẫn hiện ở đơn 1 item.
        const showQchtIcon = !!qchtRows.length && totalItems > 1

        return (
            <div className="BatchesQcPage p-5">
                <div className="row">
                    <div className="col-5 mx-auto">
                        <div className="d-flex justify-content-between align-items-baseline">
                            <h1 className='d-flex align-items-center flex-wrap'>
                                <span className='mr-4 mb-2'>QC hoàn thành</span>
                                {isMadeInVN && typeQC &&
                                    <span className="tagVN mr-2 my-1">Made in VN</span>
                                }
                                {isWoodTag && <span className="wood-tag mr-2 my-1">Sản phẩm gỗ</span>}
                                {
                                    isSpecialTag &&
                                    <Tag color="#ff0000" className="mr-2 my-1">Đặc biệt</Tag>
                                }
                                {
                                    !!brandKitItems.length &&
                                    <Tag color="#108ee9" className="mr-2 my-1">Đơn có Brand Kit</Tag>
                                }
                                {
                                    isGiftTag && <Tag color="#ff0000" className="mr-2 my-1">Hàng tặng</Tag>
                                }

                                {
                                    isSampleTag && <Tag color="#ff0000" className="mr-2 my-1">Hàng mẫu</Tag>
                                }

                                {
                                    isFbaTag && <Tag color="#ff0000" className="mr-2 my-1">FBA</Tag>
                                }

                                {
                                    isFastShipTag && <Tag color="#ff0000" className="mr-2 my-1">Ship nhanh</Tag>
                                }
                                
                                {!!isSLL &&
                                    <Tag color="#fdb813" className="mr-2 my-1">SLL</Tag>
                                }

                                {
                                    isPhotoRequest &&
                                    <div className="badge badge-pill mr-2 font-weight-bold" style={{ backgroundColor: '#b700ff', color: 'white', fontSize: '50%' }}>
                                        CHỤP ẢNH
                                    </div>
                                }
                            </h1>
                            <div className="bakestInfo">

                                {
                                    (basketInfo !== null && basketInfo !== undefined) && (
                                        <div>
                                            Số giỏ:
                                            <h4>
                                                <span className="BasketNumber text-danger">{basketInfo.number}</span>
                                                <span className="TotalItems"> / {basketInfo.total_items}</span>
                                            </h4>
                                        </div>
                                    )

                                }
                            </div>
                            {!!orderItem && !!orderItem.overtime && orderItem.overtime > 0 &&
                                <h4
                                    className="mb-0 mt-2 btn"
                                    style={{
                                        background: 'rgba(255 77 80)',
                                        color: 'white', cursor: 'auto',
                                    }}
                                >
                                    QUÁ HẠN <label
                                        className="font-weight-bold my-0">{convertDateOverTime(orderItem.overtime)}</label>
                                </h4>
                            }
                            {!!orderItem && !!orderItem.remaining_time && (orderItem.remaining_time > 0 && orderItem.remaining_time <= 1) &&
                                <h4
                                    className="mb-0 mt-2 btn"
                                    style={{
                                        background: '#ffcd3a',
                                        color: 'white', cursor: 'auto',
                                    }}
                                >
                                    Sắp quá hạn <label
                                        className="font-weight-bold my-0">{convertDateOverTime(-orderItem.remaining_time)}</label>
                                </h4>
                            }
                        </div>
                        {
                            isMultipleBrandingItems &&
                            <p className="alert alert-danger mb-4" data-context="MarkQC">BrandKit theo item</p>
                        }
                        <div className="d-flex align-items-center">
                            <div className="position-relative flex-grow-1">
                                <form onSubmit={this._onSubmit} className="formQC">
                                    <Input onPaste={this._onPaste}
                                        onChange={this._handleChange}
                                        placeholder="Nhập item cần đánh dấu"
                                        style={{ fontSize: 40, height: "auto" }}
                                        value={inputValue} ref={this._input} autoFocus />
                                    {
                                        loading && (
                                            <Icon type="sync" spin className="position-absolute IconInput" />
                                        )
                                    }

                                    {
                                        (inputValue && !loading) && (
                                            <Icon type="close-circle"
                                                className="position-absolute cursor-pointer IconInput"
                                                onClick={this._resetScanInput}
                                            />
                                        )
                                    }
                                </form>
                            </div>
                            {
                                showQchtIcon &&
                                <Tooltip title="Mô tả QCHT">
                                    <Icon type="file-text"
                                        className="ml-3 cursor-pointer IconQCHT"
                                        onClick={this._onOpenQchtModal}
                                    />
                                </Tooltip>
                            }
                        </div>

                        {errorInput && errorInput !== '' && <div className="text-danger mt-3">{errorInput}</div>}

                        {
                            errorResult && error !== '' && <div className="text-danger mt-3 font-18">{error}</div>
                        }

                        <div>
                            <div className="results d-flex align-items-baseline">
                                <div
                                    className={`d-flex align-items-center ${barCode || successResult.length > 0 || errorResult.length > 0 ? 'mt-3' : ''}`}>
                                    {
                                        barCode && (
                                            <span className="d-flex align-items-center mr-3"><h3
                                                className="mr-3">{barCode}</h3> Đã đánh dấu <strong
                                                    className="mx-1">{successResult.length + errorResult.length}</strong> barcode</span>
                                        )
                                    }
                                    {
                                        successResult.length > 0 && (
                                            <div className="mr-3"><i className="fa fa-check text-success mr-1" />
                                                <strong>{successResult.length}</strong> items thành công</div>
                                        )
                                    }
                                    {
                                        errorResult.length > 0 && (
                                            <div className="text-danger fontSize20"><i
                                                className="fa fa-times-circle mr-1" />
                                                <strong>{errorResult.length}</strong> items lỗi</div>
                                        )
                                    }
                                </div>
                            </div>

                            {
                                errorResult.length > 0 && (
                                    <ListItemsQCError
                                        dataMarkError={errorResult}
                                        arrChecked={selectedItem}
                                        updateOrdersSelected={this._updateOrdersSelected}
                                        toggleSelectAll={this._toggleSelectAllError}
                                        cancelQC={this._cancelQC}
                                        submitQC={this._submitQC}
                                        submitQC1ST={this._submitQC1ST}
                                        loading={loading}
                                    />
                                )
                            }
                        </div>
                    </div>
                    <div className="col-7">
                        {
                            !!noteOrder &&
                            <h1
                                className='text-danger mr-3 position-absolute'
                                ref={this.textRef}
                                style={{
                                    top: (storename === 'mt80szd' && isFastProductionTag && isTikTokTag && (isCutoffTag || isCutOffNoel || isCutOffNewYear)) ? '100px' : '80px',
                                    fontSize: '25px',
                                    cursor: isMoreThanTwoLines ? 'pointer' : 'unset',
                                    zIndex: 2
                                }}
                            >
                                {
                                    isMoreThanTwoLines ?
                                        <Tooltip title={noteOrder}>
                                            Note: {`${noteOrder.slice(0, 70)}...`}
                                        </Tooltip> :
                                        `Note: ${noteOrder}`
                                }
                            </h1>
                        }
                        <div className="d-flex SpecialTag w-100 align-items-baseline" style={{ top: 5 }}>
                            {storename === 'mt80szd' &&
                                <h2 className='text-danger mr-3'>Sản phẩm VIP - QC, đóng gói tách riêng</h2>
                            }
                            <div className='listTags'>
                                <div className="d-flex" style={{ minHeight: 68, alignItems: 'center' }}>
                                    {isFastProductionTag &&
                                        <span className='mr-2'>Sản xuất nhanh</span>
                                    }
                                    {isTikTokTag &&
                                        <span className='mr-2 tiktok'>TIKTOK</span>
                                    }
                                    {isCutoffTag &&
                                        <span className='mr-3'>Cutoff</span>
                                    }
                                    {isCutOffNoel &&
                                        <span className='mr-3'>Cutoff noel</span>
                                    }
                                    {isCutOffNewYear &&
                                        <span className='mr-3'>Cutoff new year</span>
                                    }
                                    {!!totalTimeQC &&
                                        <QualityControlCountDown
                                            secondsInput={totalTimeQC}
                                            sound={soundTimeOut}
                                            stopSound={this.stopSound}
                                            isCountDown={this.state.isCountDown}
                                            typeQC={typeQC}
                                            haveVIPQC={storename === 'mt80szd'}
                                        />
                                    }
                                </div>
                                {/* {
                                    typeQC && !!totalTimeQC &&
                                    <QualityControlCountDown
                                        secondsInput={totalTimeQC}
                                        sound={soundTimeOut}
                                        stopSound={this.stopSound}
                                        isCountDown={this.state.isCountDown}
                                        typeQC={typeQC}
                                        haveVIPQC={storename === 'mt80szd'}
                                    />
                                } */}
                            </div>
                        </div>
                    </div>
                </div>
                <ListItemsQC
                    isAddBasket={isAddBasket}
                    totalItems={totalItems}
                    outItems={outItems}
                    allItems={allItems}
                    typeQC={typeQC}
                    oneItem={oneItem}
                    selectedItem={selectedItem}
                    defaultChecked={defaultChecked}
                    allSelected={allSelected}
                    foundBasket={basketInfo !== null && basketInfo !== undefined}
                    loading={loading}
                    loadingQC1ST={loadingQC1ST}
                    inputValue={inputValue}
                    updateOrdersSelected={this._updateOrdersSelected}
                    toggleSelectAll={this._toggleSelectAll}
                    cancelQC={this._cancelQC}
                    submitQC={this._submitQC}
                    submitQC1ST={this._submitQC1ST}
                    reset={this._resetScanInput}
                    relatedSkuWithInputBarcode={relatedSkuWithInputBarcode}
                    refocusInput={this._focusScanInput}
                    handleCheckError={this._handleCheckError}
                    arrCheckError={arrCheckError}
                    onMarkItemError={this._onMarkItemError}
                    onCloseModal={this._onCloseModal}
                    onOpenModal={this._onOpenModal}
                    isOpen={isOpen}
                    handleChangeRadio={this._handleChangeRadio}
                    sku={sku}
                    skuSizes={skuSizes}
                    orderItem={orderItem}
                    isPhotoRequest={isPhotoRequest}
                />
                {
                    showQchtIcon &&
                    <Modal
                        title="Mô tả QCHT"
                        visible={showQchtModal}
                        onCancel={this._onCloseQchtModal}
                        width={1000}
                        className="QchtDescriptionModal"
                        footer={[
                            <Button key="close" onClick={this._onCloseQchtModal}>
                                Đóng
                            </Button>
                        ]}
                    >
                        <table className="table table-bordered mb-0">
                            <thead>
                                <tr>
                                    <th style={{ width: '20%' }}>SKU</th>
                                    <th>Nội dung mô tả QCHT</th>
                                    <th style={{ width: '30%' }}>Hình ảnh</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    //Mỗi khối mô tả là 1 row riêng, cột SKU gộp bằng rowSpan.
                                    //Quy tắc ưu tiên hiện tại chỉ cho tối đa 1 khối nên thực tế 1 SKU = 1 row;
                                    //giữ map/rowSpan để đổi quy tắc sau này chỉ cần sửa helper
                                    qchtRows.map(row => row.descriptions.map((item, itemIndex) => (
                                        <tr key={`${row.key}_${item.brand}`}>
                                            {
                                                itemIndex === 0 &&
                                                <td rowSpan={row.descriptions.length}>
                                                    <div><strong>{row.type}</strong></div>
                                                    {
                                                        !!item.brand &&
                                                        <div className="badge badge-danger badge-pill mt-1">{item.brand}</div>
                                                    }
                                                </td>
                                            }
                                            <td>
                                                <div className="brand-description">
                                                    {
                                                        !!item.description &&
                                                        <div className="description">
                                                            <pre>{item.description}</pre>
                                                        </div>
                                                    }
                                                </div>
                                            </td>
                                            <td>
                                                {
                                                    !!item.images.length &&
                                                    <div className="brand-description">
                                                        <div className="images">
                                                            {
                                                                item.images.map((img, index) => (
                                                                    <div className="image-item" key={`${row.key}_${item.brand}_img_${index}`}>
                                                                        <img src={img} alt="preview" />
                                                                        <EyeTwoTone
                                                                            className='eyes-image-item'
                                                                            onClick={() => this.setState({ qchtPreviewImage: img })}
                                                                        />
                                                                    </div>
                                                                ))
                                                            }
                                                        </div>
                                                    </div>
                                                }
                                            </td>
                                        </tr>
                                    )))
                                }
                            </tbody>
                        </table>
                    </Modal>
                }
                {/* Modal preview ảnh của popup: KHÔNG refocus ô quét khi đóng, vì popup "Mô tả QCHT"
                    cha vẫn đang mở — đưa focus ra ô Input dưới mask sẽ cho súng scan bắn "mù" sau lưng
                    popup, và showQchtModal của đơn trước sẽ theo sang đơn sau. Để rc-dialog trả focus về
                    icon con mắt trong dialog; ô quét chỉ refocus ở _onCloseQchtModal. */}
                {
                    !!qchtPreviewImage &&
                    <Modal
                        title={'Preview image'}
                        visible={!!qchtPreviewImage}
                        footer={null}
                        zIndex={1050}
                        onCancel={() => this.setState({ qchtPreviewImage: '' })}
                    >
                        <img
                            alt="preview"
                            style={{ width: '100%' }}
                            src={qchtPreviewImage}
                        />
                    </Modal>
                }
            </div>
        )
    }
}

export default MarkQC
